import React, { useEffect } from "react";
// styled components
import { Divider, Form, Input, Select, Button } from "antd";
// data select
import { CoberturaBepsOptions } from "../../../../../utils/dataSelectOptions";
// route
import { useNavigate } from "react-router";
// models
import { useCrearConvocatoria } from "./useCrearConvocatoria";

// api services
import apiConvocatorias from "../../../../../api/Convocatorias/api-convocatorias";
import { useMaestras } from "../../../../../hooks/useMaestras";
import { useEncrypt } from "../../../../../hooks/useEncrypt";
import DocumentInput from "../../../../../utils/DocumentInput";
interface IProps {
  cambiarPestaña: any;
}

export const CrearConvocatoria: React.FC<IProps> = (props: IProps) => {
  // route
  const navigate = useNavigate();
  // redux
  const { decrypt } = useEncrypt();

  const {
    convocatoriabeps,
    setConvocatoriasBeps,
    guardarycontinuar,
    guardarArchivo,
    guardoArchivo,
    setGuardoArchivo,
    handleChange,
    setPortada,
    portada,
    fileInputRef
  } =
    useCrearConvocatoria();

  const idConvocatoria = decrypt(localStorage.getItem("id_convocatoria"));

  const { obtenerEntidades, entidades, obtenerAreas, areas } = useMaestras();
  // start component
  useEffect(() => {
    obtenerAreas();
    obtenerEntidades();
  }, []);

  useEffect(() => {
    handleChange(portada, "portada_url");
  }, [portada])

  useEffect(() => {
    if (Boolean(decrypt(localStorage.getItem("editar_convocatoria")))) {
      cargarConvocatoria();
      return;
    }
    setConvocatoriasBeps({
      nombre_convocatoria: "",
      area: [],
      entidad: "",
      cobertura: "",
      descripcion_corta: "",
      perfil_participante: "",
      fechas: [],
      documentos: [],
      tipo_participante: [],
      tipo: 3,
      portada_url: ""
    });
  }, [localStorage.getItem("editar_convocatoria")]);

  // function
  const cargarConvocatoria = async () => {
    let { data } = await apiConvocatorias.getConvocatoriaById(idConvocatoria);
    let dataareas = data.area.map((x: any) => x.value);
    setConvocatoriasBeps({
      nombre_convocatoria: data.nombre_convocatoria,
      area: dataareas,
      entidad: data.entidad,
      cobertura: data.cobertura,
      descripcion_corta: data.descripcion_corta,
      perfil_participante: data.perfil_participante,
      tipo_participante: data.tipo_participante,
      tipo: data.tipo,
      fechas: data.fechas,
      documentos: data.documentos_generales,
      portada_url: data.portada_url
    });
    return setPortada(data.portada_url);
  };
  // campos
  const fields = [
    {
      name: "nombre_convocatoria",
      value: convocatoriabeps.nombre_convocatoria,
    },
    { name: "area", value: convocatoriabeps.area },
    { name: "entidad", value: convocatoriabeps.entidad },
    { name: "cobertura", value: convocatoriabeps.cobertura },
    { name: "descripcion_corta", value: convocatoriabeps.descripcion_corta },
    {
      name: "perfil_participante",
      value: convocatoriabeps.perfil_participante,
    },
    { name: "portada_url", value: convocatoriabeps.portada_url },
  ];
  return (
    <>
      <div
        className="container-fluid ps-md-4 pe-md-4 main-c4"
        style={{ marginBottom: "16px" }}
      >
        <div className="row-shadow mt-3 mb-3">
          <div className="container-row-shadow">
            <div className="row">
              <div className="col-12 col-md-8 pb-2 font-size-14px font-family-Montserrat-Regular">
                Información general de la convocatoria -{" "}
                <span className="font-size-10px font-color-9F0505">
                  Todos los campos son obligatorios
                </span>
              </div>
              <div className="col-8 col-md-4 pb-2 d-flex justify-content-md-end font-color-B0B0B0 font-size-12px font-family-Montserrat-Regular">
                Código de convocatoria: {idConvocatoria}
              </div>
            </div>
            <Divider className="no-margin" />
            <Form
              name="crearConvocatoriaBeps"
              size="large"
              layout="vertical"
              className="width-100"
              onFinish={() => guardarycontinuar(props.cambiarPestaña)}
              fields={fields}
              onFieldsChange={(_: any, fields: any) => {
                let infoupdate: any = { ...convocatoriabeps };
                infoupdate[_[0].name[0]] = _[0].value;
                setConvocatoriasBeps(infoupdate);
              }}
            >
              <div className="row mt-3">
                <div className="col-12">
                  <Form.Item
                    className="no-margin"
                    label="Nombre de convocatoria"
                    name="nombre_convocatoria"
                    rules={[{ required: true, message: "Campo obligatorio" }]}
                  >
                    <Input style={{ width: "100%" }} maxLength={300} />
                  </Form.Item>
                </div>
                <div className="col-12">
                  <Form.Item
                    className="no-margin"
                    label="Área"
                    name="area"
                    rules={[{ required: true, message: "Campo obligatorio" }]}
                  >
                    <Select
                      mode="multiple"
                      style={{ width: "100%" }}
                      placeholder="Seleccionar.."
                    >
                      {areas.map(({ id, nombre }: any) => (
                        <Select.Option key={id} value={nombre}>{nombre}</Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </div>
                <div className="col-12 col-md-6">
                  <Form.Item
                    className="no-margin"
                    label="Entidad"
                    name="entidad"
                    rules={[{ required: true, message: "Campo obligatorio" }]}
                  >
                    <Select
                      style={{ width: "100%" }}
                      placeholder="Seleccionar.."
                    >
                      {entidades.map(({ id, nombre }: any) => (
                        <Select.Option key={id} value={nombre}>{nombre}</Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </div>
                <div className="col-12 col-md-6">
                  <Form.Item
                    className="no-margin"
                    label="Cobertura"
                    name="cobertura"
                    rules={[{ required: true, message: "Campo obligatorio" }]}
                  >
                    <Select
                      style={{ width: "100%" }}
                      placeholder="Seleccionar.."
                    >
                      {CoberturaBepsOptions.map(({ value, text }) => (
                        <Select.Option key={value} value={value}>
                          {text}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </div>
                <div className="col-12">
                  <Form.Item
                    label="Imagen Portada " /* rules={[{ required: true, message: "" }]} */
                    name="portada_url"
                  >
                    <DocumentInput
                      doc={typeof (portada) == 'undefined' ? fields : portada || ""}
                      fileInputRef={fileInputRef}
                      tipos_doc=", JPG, PNG."
                      setGuardoArchivo={setGuardoArchivo}
                      on_change={(e) => {
                        setGuardoArchivo(true);
                        guardarArchivo(e);
                        e.target.value = "";
                      }}
                      onDelete={async () => {
                        return setPortada("");
                      }}
                    />
                  </Form.Item>
                </div>
                <div className="col-12 col-md-6">
                  <Form.Item
                    className="no-margin"
                    label="Descripción"
                    name="descripcion_corta"
                    rules={[{ required: true, message: "Campo obligatorio" }]}
                  >
                    <Input.TextArea
                      maxLength={2000}
                      showCount={true}
                      rows={4}
                      style={{ width: "100%" }}
                    />
                  </Form.Item>
                </div>
                <div className="col-12 col-md-6">
                  <Form.Item
                    className="no-margin"
                    label="¿Quien puede participar?"
                    name="perfil_participante"
                    rules={[{ required: true, message: "Campo obligatorio" }]}
                  >
                    <Input.TextArea
                      maxLength={2000}
                      showCount={true}
                      rows={4}
                      style={{ width: "100%" }}
                    />
                  </Form.Item>
                </div>
              </div>
            </Form>
          </div>
        </div>
      </div>
      <div className="container-sticky-footer">
        <div className="row">
          <div className="col justify-content-flex-start">
            <Button
              className="button-blanco-radius"
              onClick={() => navigate("/administrador")}
            >
              Atrás
            </Button>
          </div>
          <div className="col justify-content-flex-end">
            <Button
              className="button-azul-radius"
              htmlType="submit"
              form="crearConvocatoriaBeps"
            >
              Guardar y continuar
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};
